import Vue from 'vue'
import { decode } from '@/lib/util'
import './bundle-info.vue'
import '../tabs/tabs.vue'
import '../product-card/product-card.vue'

export default el => new Vue({
  name: 'Bundle info',
  el,
  data () {
    const sectionSettings = JSON.parse(decode(el.getAttribute('settings-data')))
    return {
      ...sectionSettings
    }
  }
})